<template>
  <div class="playingCardComponent">
    <VuePlayingCard :width="width" :height="height" :signature="cardString" :key="cardString" />
  </div>
</template>

<script>
import { VuePlayingCard } from "vue-playing-card";

export default {
  components: { VuePlayingCard },
  props: {
    cardString: { type: String, required: true },
    height: Number,
    width: Number,
  },
};
</script>

<style lang="scss" scoped>
.playingCardComponent {
  display: inline-block;
}
</style>
